export const duration = {
  instant: 0,
  fastest: 75,
  fast: 150,
  normal: 200,
  slow: 300,
  slower: 500,
  slowest: 700
} as const;

export type DurationKey = keyof typeof duration;

export const timing = {
  linear: 'linear',
  ease: 'ease',
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  easeOut: 'cubic-bezier(0, 0, 0.2, 1)',
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  bounce: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
} as const;

export type TimingKey = keyof typeof timing;
